import {CHART_LAYOUT_STORAGE_KEY} from '../constants/CHART_LAYOUT_STORAGE_KEY';
import type {ChartLayout} from '../types/ChartLayout';

export function writeStoredChartLayout(layout: ChartLayout) {
  try {
    localStorage.setItem(CHART_LAYOUT_STORAGE_KEY, JSON.stringify(layout));
  } catch {
    // A browser that blocks storage keeps the layout until the page reloads.
  }
}
